import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {ChartsModule} from 'ng2-charts';
import {AppComponent} from './app.component';
import {PublicQuoteLayoutComponent} from './layout/containers/public-quote-layout';
import {DashboardComponent} from './modules/core/dashboard/dashboard.component';
import {BaseService} from './services/base/base.service'

// Import custom modules
import {AppRoutingModule} from './app.routing';
import {SecurityModule} from './modules/security/security.module';
import {SharedModule} from './modules/shared/shared.module';

// === APP_CONTAINERS ===
import {
  FullLayoutComponent,
  SimpleLayoutComponent,
} from './layout/containers';

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent,
  PublicQuoteLayoutComponent,
];

// === APP_LAYOUT_COMPONENTS ===
import {
  APP_SIDEBAR_NAV,
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
} from './layout/components';

const APP_LAYOUT_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV,
];

const APP_CUSTOM_COMPONENTS = [
  DashboardComponent,
];
// === APP_DIRECTIVES ===

import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
} from './layout/directives';

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
];
// Import 3rd party components
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {TabsModule} from 'ngx-bootstrap/tabs';

// AoT requires an exported function for  factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ButtonsModule.forRoot(),
    ChartsModule,
    HttpClientModule,
    SharedModule,
    SecurityModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
    AppComponent,
    APP_CONTAINERS,
    APP_LAYOUT_COMPONENTS,
    APP_CUSTOM_COMPONENTS,
    APP_DIRECTIVES,
  ],
  providers: [{
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    BaseService,
    TranslateService],
  bootstrap: [AppComponent],
})
export class AppModule {
}
